import scratchblocks from 'scratchblocks'

import locales from './scratchblocksLocales'

const localeMap = {
  'am-ET': 'am',
  'ar-SA': 'ar',
  'az-AZ': 'az',
  'be-BY': 'be',
  'bg-BG': 'bg',
  'bn-BD': 'en',
  'ca-ES': 'ca',
  'ckb-IR': 'ckb',
  'cs-CZ': 'cs',
  'cy-GB': 'cy',
  'da-DK': 'da',
  'de-DE': 'de',
  'el-GR': 'el',
  'es-ES': 'es',
  'es-LA': 'es_419',
  'et-EE': 'et',
  'eu-ES': 'eu',
  'fa-IR': 'fa',
  'fi-FI': 'fi',
  'fr-CA': 'fr',
  'fr-FR': 'fr',
  'ga-IE': 'ga',
  'gd-GB': 'gd',
  'gl-ES': 'gl',
  'he-IL': 'he',
  'hi-IN': 'en',
  'hr-HR': 'hr',
  'hu-HU': 'hu',
  'id-ID': 'id',
  'is-IS': 'is',
  'it-IT': 'it',
  'ja-JP': 'ja',
  ja_Hira: 'ja_Hira',
  'ko-KR': 'ko',
  'lt-LT': 'lt',
  'lv-LV': 'lv',
  'me-ME': 'en',
  'mi-NZ': 'mi',
  'mr-IN': 'en',
  'nl-NL': 'nl',
  'no-NO': 'nb',
  'pl-PL': 'pl',
  'pt-BR': 'pt_br',
  'pt-PT': 'pt',
  'ro-RO': 'ro',
  'ru-RU': 'ru',
  'sk-SK': 'sk',
  'sl-SL': 'sl',
  'sr-SP': 'sr',
  'sv-SE': 'sv',
  'th-TH': 'th',
  'tr-TR': 'tr',
  'uk-UA': 'uk',
  'vi-VN': 'vi',
  'vls-BE': 'en',
  'xh-ZA': 'xh',
  'zh-CN': 'zh_cn',
  'zh-TW': 'zh_tw',
  'zu-ZA': 'zu',
}

export const scratchblocksInit = (project, currentLocale) => {
  if (!isScratchProject(project)) {
    return null
  }

  const selectors = {
    '.language-blocks': 'scratch2',
    '.language-blocks3': 'scratch3',
  }

  return Object.entries(selectors).forEach((entry) => {
    const [selector, style] = entry
    const elements = document.querySelectorAll(selector)

    Array.from(elements).map((block) =>
      renderScratchblock(block, currentLocale, style)
    )
  })
}

export const isScratchProject = (project) =>
  project.software.indexOf('scratch') !== -1

export const renderScratchblock = (block, currentLocale, style) => {
  scratchblocks.loadLanguages(locales)

  let parsed = scratchblocks.parse(block.innerHTML, {
    style,
  })

  parsed.translate(scratchblocksLocale(currentLocale))

  let translated = scratchblocks.newView(parsed, {
    style,
  })

  let svg = translated.render()

  if (style === 'scratch3') {
    svg.style.transform = 'scale(1)'
    svg.style.transformOrigin = '0 0'
  }

  block.parentNode.setAttribute('dir', 'ltr')
  block.parentNode.insertBefore(svg, block)
  block.parentNode.removeChild(block)
}

export const scratchblocksLocale = (currentLocale) => {
  const languages = scratchblocks.allLanguages
  const locale = localeMap[currentLocale]

  if (languages[locale]) {
    return languages[locale]
  }

  return languages.en
}

const ScratchblocksHelper = {
  isScratchProject,
  renderScratchblock,
  scratchblocksInit,
  scratchblocksLocale,
}

export default ScratchblocksHelper
